import { render, staticRenderFns } from "./EducationalGroupStudentTable.vue?vue&type=template&id=7f396ff4&"
import script from "./EducationalGroupStudentTable.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupStudentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports